import { useEffect, useMemo, useState } from "react";
import { EVM_CONFIG } from "../../config";
import type { EIP6963ProviderDetail } from "../../base-app/hooks/useEIP6963";
import {
  connectKitEnabled,
  loadDogeOsConnectKitConnectors,
  mergeWalletChoices,
  type DogeOsConnectKitConnector,
} from "./connectKit";

/**
 * The wallet choices for the modal: EIP-6963 announcements, plus the DogeOS
 * connect-kit connectors when the kit is enabled and this page serves DogeOS
 * Chikyu. On the Base route the result is the announcement list itself.
 */
export function useDogeOsConnectKit(
  announced: EIP6963ProviderDetail[],
): EIP6963ProviderDetail[] {
  const active =
    connectKitEnabled() && EVM_CONFIG.NETWORK?.registryKey === "dogeos-chikyu";
  const [connectors, setConnectors] = useState<DogeOsConnectKitConnector[]>([]);
  useEffect(() => {
    if (!active) return;
    let cancelled = false;
    void loadDogeOsConnectKitConnectors({ enabled: true }).then((found) => {
      if (!cancelled) setConnectors(found);
    });
    return () => {
      cancelled = true;
    };
  }, [active]);
  return useMemo(
    () => (active ? mergeWalletChoices(announced, connectors) : announced),
    [active, announced, connectors],
  );
}
